import { getKey, setKey } from '@/helpers/storage';

type ExternalApplicationFlagType = {
  completed: boolean;
};

export const getExternalApplicationFlag = (): ExternalApplicationFlagType =>
  getKey<ExternalApplicationFlagType>('external-application-flow', { completed: false });

export const setExternalApplicationFlagAsCompleted = (): void => {
  setKey('external-application-flow', { completed: true });
};
